import MovimientoOperador from "./MovimientoOperador";
export default MovimientoOperador;